<template>
    <div class="container">
        <div class="col-sm-3 col-xs-2"></div>
        <div class="col-sm-6 col-xs-8">
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="text" v-model="unitNumber" name="unitNumberSearch" class="form-control" placeholder="Unit Number" @keyup.enter="search"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="text" v-model="vin" name="vinSearch" class="form-control" placeholder="VIN" @keyup.enter="search"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="text" v-model="plateNo" name="plateNoSearch" class="form-control" placeholder="Plate Number" @keyup.enter="search"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            </div>
            <br>
            <div class="row">
                <div class="col-xs-12"><button class="btn btn-primary" @click="search">Search</button></div>
            </div>
        <div class="col-sm-3 col-xs-2"></div>
        <div id="loading" v-show="displayLoading">
            <h1>Loading</h1>
            <span>.</span><span>.</span><span>.</span>
        </div>
    </div>
</template>

<script>
  import swal from 'sweetalert2'
  import axios from 'axios'

  export default {
    name: 'search-page',
    data () {
      return {
        vin: '',
        plateNo: '',
        unitNumber: '',
        displayLoading: false
      }
    },
    methods: {
      search () {
        this.displayLoading = true
        let errorMessage = ''
        if (this.vin.trim().length === 0 || this.vin.trim().length < 8) {
          errorMessage += 'VIN (minimum length of 8 characters)<br>'
        }
        if ((this.unitNumber.trim().length === 0 || this.unitNumber.trim().length < 4) && errorMessage !== '') {
          errorMessage += 'Unit Number (minimum length of 4 characters)<br>'
        } else if (this.vin.trim().length === 0 && errorMessage.length > 0) {
          errorMessage = ''
        }
        if ((this.plateNo.trim().length === 0 || this.plateNo.trim().length < 4) && errorMessage !== '') {
          errorMessage += 'Plate Number (minimum length of 4 characters)<br/>'
        } else if (this.vin.trim().length === 0 && errorMessage.length > 0) {
          errorMessage = ''
        } else if (this.unitNumber.trim().length === 0 && errorMessage.length > 0) {
          errorMessage = ''
        }
        if (errorMessage.length !== 0) {
          swal({
            title: 'Please enter a valid version of at least one of the following:',
            html: errorMessage
          })
          return false
        }
        axios.post('./static/api/Ajax.php', {
          VIN: this.vin,
          PlateNo: this.plateNo,
          UnitNumber: this.unitNumber,
          action: 'Search'
        }).then((response) => {
          console.log(response)
          if (response.data.status === 'success') {
            this.$store.commit('searchResults', response.data.data)
            window.location = './#/results'
          } else if (response.data.status) {
            swal(response.data.status)
          }
        }).catch((e) => {
          console.log(e)
        })
      }
    }
  }
</script>

<style scoped>
    #loading{
        font-family:Lucida Grande, Helvetica, Verdana, sans-serif;
        background:rgba(0,0,0,1);
        color:#f2f2f2;
        overflow:hidden;
        top: 0;
        left: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }
    #loading h1{position:absolute;top:50%;left:50%;height:40px;line-height:40px;width:160px;margin:-20px 0 0 -80px;text-align:center;font-weight:normal;}
    #loading span{-webkit-animation:load 4s infinite ease-in-out;position:absolute;top:51%;height:10px;width:30px;text-align:right;font-size:200%;margin-left:-15px;}
    #loading span:nth-child(2){-webkit-animation-delay:.2s;width:20px;}
    #loading span:nth-child(3){-webkit-animation-delay:.4s;width:10px;}
    @-webkit-keyframes load{
        0%{left:-2%;}
        40%{left:50%;}
        60%{left:50%;}
        100%{left:102%;}
    }
</style>


// WEBPACK FOOTER //
// src/components/searchPage.vue